import { useNavigate, useSearchParams } from 'react-router-dom';

import { useCadastro as useCadastroDoNucleo } from '@maestra/core/telas/auth/useCadastro';

// O CADASTRO: a regra mora no núcleo desde 01/11/2026, e o app usa a mesma (docs/PLANO-APP-NATIVO.md).
// A web entrega o `navigate` e o e-mail que já chega: o do convite (`?email=`) ou, depois, o que a
// pessoa digitou na landing (cartão final "comece grátis").

const emailDaLanding = () => {
  try {
    const seed = sessionStorage.getItem('signup_email') || '';
    if (seed) sessionStorage.removeItem('signup_email');
    return seed;
  } catch {
    return '';
  }
};

export const useCadastro = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  return useCadastroDoNucleo({ ir: navigate, emailInicial: params.get('email') || emailDaLanding() });
};

export { IDADE_MINIMA } from '@maestra/core/telas/auth/useCadastro';
export type { CampoDoCadastro, ErrosDoCadastro } from '@maestra/core/telas/auth/useCadastro';
